import React, { useEffect } from 'react';
import styled from 'styled-components';
import ErrorBoundary from '../components/errorBoundary';
import { fadeIn } from '../constants/keyframes/fades';
import useGetPage from '../hooks/useGetPage';
import ServerError from '../pages/serverError';

const FadeInWrapper = styled.div`
	opacity: 0;
	animation: ${fadeIn} 400ms linear forwards;
`;

const pageWrapper = Component => props => {
	const { componentId } = props;
	const page = useGetPage(componentId);

	useEffect(() => {
		if (page) {
			document.title = `${page.Name} - Pósturinn`;
		}
	}, [page]);

	if (page === null) return null;

	return (
		<FadeInWrapper>
			<ErrorBoundary fallback={<ServerError />}>
				<Component {...props} page={page} />
			</ErrorBoundary>
		</FadeInWrapper>
	);
};

export default pageWrapper;
